module.exports = __webpack_public_path__ + "static/services-e6e94a83e258273155c0a0cece866729.jpg";